import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfileService } from './api/user-profile.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardGuard {
  constructor(
    private router: Router,
    private userProfileService: UserProfileService
  ) { }

  canActivate() {
    if (this.userProfileService.isUserAdminRole() || this.userProfileService.isUserFinanceRole()) {
      return true;
    }
    return this.router.createUrlTree(['/landing']);
  }

  canActivateChild() {
    return this.canActivate();
  }

}
